import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';

import { ApiCmsConfiguration } from './api-cms-configurations.models';


type DeviceCode = 'webApp' | 'androidApp' | 'iosApp' | 'storeApp';
export interface ApiCmsConfigurationsServiceInterface {
  configurations(storeCode: string, deviceFilter?: DeviceCode): Observable<ApiCmsConfiguration[]>;
}

@Injectable()
export class ApiCmsConfigurationsService implements ApiCmsConfigurationsServiceInterface {

  constructor(
    private readonly ecommerceConfigService: EcommerceConfigService,
    private readonly http: HttpClient
  ) {}

  public configurations(storeCode: string, deviceFilter?: DeviceCode): Observable<ApiCmsConfiguration[]> {
    const iConfigsJSON = sessionStorage.getItem('iConfigsJSON');
    if (iConfigsJSON) {
      return of(JSON.parse(iConfigsJSON));
    }

    const url = this.requestUrl(storeCode, deviceFilter);
    if (url === undefined) {
      return of([]);
    }

    return this.http.get<ApiCmsConfiguration[]>(url);
  }

  private requestUrl(storeCode: string, deviceFilter?: DeviceCode): string | undefined {
    const { cmsConfigurationsStaticBaseUrl, cmsConfigurationsBaseUrl } = this.ecommerceConfigService.getConfig().providers;
    if (cmsConfigurationsStaticBaseUrl) {
      return `${cmsConfigurationsStaticBaseUrl}/config-${storeCode}.json`;
    }

    if (cmsConfigurationsBaseUrl) {
      const deviceParam = deviceFilter ? `?device=${deviceFilter}` : '';
      return `${cmsConfigurationsBaseUrl}/${storeCode}${deviceParam}`;
    }

    return undefined;
  }

}
